import * as Scrivito from "scrivito"

export const StorylaneWidget = Scrivito.provideWidgetClass("StorylaneWidget", {
  attributes: {
    headline: ["widgetlist", { only: "TextWidget", maximum: 1 }],
    text: ["widgetlist", { only: "TextWidget", maximum: 1 }],
    storylaneDesktopDemoId: "string",
    storylaneTabletDemoId: "string",
    storylaneMobileDemoId: "string",
    scrollTargetId: "string"
  }
})
